import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'properties/style/bar.ejs';
import { pickerCfg } from 'pickerCfg.js';

class StyleBarView extends BasePropertyView {

    initialize(opts) {
        super.initialize(opts);

        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        // !! Use Specific ids for hooking events when possible !!
        this.events = {
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]': 'getFocus',
            'change input[type=text]' : 'updateColorAttributesWithValidation',
            'change input[type=color]': 'updateColorAttributes'
        };

        return this;
    }

    render() {
        super.render();
        this.$el.html(this.template(this.model.toJSON()));

        //.$('input[type=color]', this.$el).spectrum(pickerCfg);

        this.delegateEvents();

        return this;
    }

}

export default StyleBarView;
